import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HomeComponent} from './home.component';
import {RouterModule} from '@angular/router';
import {ArticlesResolver, HomeCarouselItemsResolver, SharedModule} from '../shared';
import {ReferencesComponent} from './references/references.component';
import {ServicesComponent} from './services/services.component';
import {ContactComponent} from './contact/contact.component';
import {PartnersComponent} from './partners/partners.component';
import {ReferenceComponent} from './reference/reference.component';
import {NgMasonryGridModule} from 'ng-masonry-grid';
import {EmbedVideo} from 'ngx-embed-video/dist';
import {NgxResponsiveEmbedModule} from 'ngx-responsive-embed';
import {AngularSvgIconModule} from 'angular-svg-icon';
import 'hammerjs';
import {ArticlePreviewComponent} from './article-preview/article-preview.component';
import {TechnicalDescriptionPageComponent} from './about-page/technical-description-page.component';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {AdminComponent} from './admin/admin.component';
import {ArticleManagerPage} from './admin/components/article-manager/article-manager-page.component';
import {AngularFireStorageModule} from '@angular/fire/storage';
import {NgxHmCarouselModule} from 'ngx-hm-carousel';
import {HomeCarouselManagerPage} from './admin/components/home-carousel-manager/home-carousel-manager-page.component';
import {ReferenceManagerPageComponent} from './admin/components/reference-manager-page/reference-manager-page.component';
import {ReferencesResolver} from '../shared/resolvers/references-resolver.service';
import {AuthComponent} from './auth/auth.component';
import {PartnerManagerPage} from './admin/components/partner-manager/partner-manager-page.component';
import {PartnerItemsResolver} from '../shared/resolvers/partner-items-resolver.service';
import {ArticlePageComponent} from './article-page/article-page.component';
import {ArticlesComponent} from './articles/articles.component';
import {ArticleResolver} from '../shared/resolvers/article-resolver.service';
import {FlatManagerPageComponent} from './admin/components/flat-manager-page/flat-manager-page.component';
import {FlatsResolver} from '../shared/resolvers/flats-resolver.service';
import {FlatsComponent} from './flats/flats.component';
import {FlatComponent} from './flats/flat/flat.component';
import {MarketingItemManagerPageComponent} from './admin/components/marketing-item-manager-page/marketing-item-manager-page.component';
import {MarketingItemsResolverService} from '../shared/resolvers/marketing-items-resolver.service';
import {RealEstateAgentManagerComponent} from './admin/components/real-estate-agent-manager/real-estate-agent-manager.component';
import {RealEstateAgentItemsResolver} from '../shared/resolvers/real-estate-agent-items-resolver.service';
import {NgxGalleryModule} from '@kolkov/ngx-gallery';
import {GalleryManagerPageComponent} from './admin/components/gallery-manager-page/gallery-manager-page.component';
import {GalleryResolverService} from '../shared/resolvers/gallery-resolver.service';
import {GalleriesComponent} from './galleries/galleries.component';

const homeRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'flats',
    component: FlatsComponent
  },
  {
    path: 'flat/:id',
    component: FlatComponent
  },
  {
    path: 'auth',
    component: AuthComponent
  },
  {
    path: 'technical-description',
    component: TechnicalDescriptionPageComponent
  },
  {
    path: 'references',
    component: ReferencesComponent
  },
  {
    path: 'reference/:id',
    component: ReferenceComponent
  },
  {
    path: 'services',
    component: ServicesComponent
  },
  {
    path: 'contact',
    component: ContactComponent
  },
  {
    path: 'partners',
    component: PartnersComponent
  },
  {
    path: 'article/:id',
    component: ArticlePageComponent,
    resolve: {
      article: ArticleResolver
    }
  },
  {
    path: 'articles',
    component: ArticlesComponent,
    resolve: {
      articlesResolve: ArticlesResolver
    }
  },
  {
    path: 'galleries',
    component: GalleriesComponent,
  },
  {
    path: 'admin',
    component: AdminComponent,
    children: [
      {
        path: 'flat-manager',
        component: FlatManagerPageComponent,
        resolve: {
          flatsResolve: FlatsResolver
        }
      },
      {
        path: 'article-manager',
        component: ArticleManagerPage,
        resolve: {
          articlesResolve: ArticlesResolver
        }
      },
      {
        path: 'home-carousel-manager',
        component: HomeCarouselManagerPage,
        resolve: {
          homeCarouselItemsResolve: HomeCarouselItemsResolver
        }
      },
      {
        path: 'reference-manager',
        component: ReferenceManagerPageComponent,
        resolve: {
          referencesResolve: ReferencesResolver
        }
      },
      {
        path: 'gallery-manager',
        component: GalleryManagerPageComponent,
        resolve: {
          galleriesResolve: GalleryResolverService
        }
      },
      {
        path: 'partner-manager',
        component: PartnerManagerPage,
        resolve: {
          partnersResolve: PartnerItemsResolver
        }
      },
      {
        path: 'marketing-manager',
        component: MarketingItemManagerPageComponent,
        resolve: {
          marketingItemsResolver: MarketingItemsResolverService
        }
      },
      {
        path: 'real-estate-agent-manager',
        component: RealEstateAgentManagerComponent,
        resolve: {
          realEstateAgentItemsResolver: RealEstateAgentItemsResolver
        }
      }
    ]
  }
]);

@NgModule({
  declarations: [
    HomeComponent,
    ReferencesComponent,
    ServicesComponent,
    ContactComponent,
    PartnersComponent,
    ReferenceComponent,
    ArticlePreviewComponent,
    TechnicalDescriptionPageComponent,
    AdminComponent,
    ArticleManagerPage,
    HomeCarouselManagerPage,
    ReferenceManagerPageComponent,
    PartnerManagerPage,
    AuthComponent,
    ArticlePageComponent,
    ArticlesComponent,
    FlatManagerPageComponent,
    FlatsComponent,
    FlatComponent,
    RealEstateAgentManagerComponent,
    GalleryManagerPageComponent,
    GalleriesComponent
  ],
  imports: [
    homeRouting,
    SharedModule,
    CommonModule,
    NgMasonryGridModule,
    NgxGalleryModule,
    EmbedVideo,
    AngularSvgIconModule,
    NgxResponsiveEmbedModule,
    CKEditorModule,
    AngularFireStorageModule,
    NgxHmCarouselModule
  ]
})
export class HomeModule {
}
